import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from '@raysync/common/components'
import { PostCardContainer, PostCardImg, PostCardContent, PostCardTitle, PostCardMsg } from './atoms'

const Container = styled(PostCardContainer)`
  padding: 10px;
  margin-bottom: 0;
  border-radius: 10px;
  ${PostCardImg} {
    width: unset;
    img {
      width: 120px;
      min-width: 120px;
      height: 80px;
    }
  }
  ${PostCardContent} {
    margin-right: 0;
  }
  ${PostCardTitle} {
    a {
      font-size: 14px;
      line-height: 1.5;
    }
  }
  ${PostCardMsg} {
    font-size: 12px;
    margin-top: 16px;
  }
`

class HotCard extends React.PureComponent {
  render() {
    const { title, slug, img, date, isBlog } = this.props
    return (
      <Container>
        <Link to={`/${isBlog ? 'blog' : 'news'}/${slug}/`}>
          <PostCardImg>{img ? <img src={img} alt={title} /> : <div></div>}</PostCardImg>
        </Link>
        <PostCardContent>
          <PostCardTitle>
            <Link to={`/${isBlog ? 'blog' : 'news'}/${slug}/`}>{title}</Link>
          </PostCardTitle>
          <PostCardMsg>{date}</PostCardMsg>
        </PostCardContent>
      </Container>
    )
  }
}

HotCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
}

export default HotCard
